import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Sites API
export const sitesApi = {
  analyze: (location, radius_km = 5) =>
    api.post('/api/v1/sites/analyze', { location, radius_km }),

  create: (siteData) =>
    api.post('/api/v1/sites/', siteData),

  list: (skip = 0, limit = 100) =>
    api.get('/api/v1/sites/', { params: { skip, limit } }),

  get: (siteId) =>
    api.get(`/api/v1/sites/by-id/${siteId}`),

  delete: (siteId) =>
    api.delete(`/api/v1/sites/by-id/${siteId}`),

  analyzeArea: (lat, lon, country = 'NO') =>
    api.post('/api/v1/sites/analyze-area', { lat, lon, country }),
};

// Layers API
export const layersApi = {
  getGridConnections: (bbox = null) =>
    api.get('/api/v1/layers/grid-connections', { params: { bbox } }),

  getEnvironmentalConstraints: (bbox = null, constraint_type = null) =>
    api.get('/api/v1/layers/environmental-constraints', {
      params: { bbox, constraint_type }
    }),

  getInfrastructure: (bbox = null, infrastructure_type = null) =>
    api.get('/api/v1/layers/infrastructure', {
      params: { bbox, infrastructure_type }
    }),

  getEnergyResources: (bbox = null, resource_type = null) =>
    api.get('/api/v1/layers/energy-resources', {
      params: { bbox, resource_type }
    }),

  getPorts: (bbox = null, port_type = null, municipality = null, limit = 500) =>
    api.get('/api/v1/layers/ports', {
      params: { bbox, port_type, municipality, limit }
    }),

  getZoning: (bbox = null, arealformaal = null, municipality = null, limit = 1000) =>
    api.get('/api/v1/layers/zoning', {
      params: { bbox, arealformaal, municipality, limit }
    }),

  getGridStrengthZones: (bbox = null, zone_category = null, min_voltage = null) =>
    api.get('/api/v1/layers/grid-strength-zones', {
      params: { bbox, zone_category, min_voltage }
    }),
};

// Payments API
export const paymentsApi = {
  createSubscription: (subscriptionData) =>
    api.post('/api/v1/payments/create-subscription', subscriptionData),

  cancelSubscription: () =>
    api.post('/api/v1/payments/cancel-subscription'),

  getSubscriptionStatus: () =>
    api.get('/api/v1/payments/subscription-status'),
};

export default api;
